import { render } from "./SeismicView3D.vue?vue&type=template&id=70280b24&ts=true"
import script from "./SeismicView3D.vue?vue&type=script&lang=ts"
export * from "./SeismicView3D.vue?vue&type=script&lang=ts"

import "./SeismicView3D.vue?vue&type=style&index=0&id=70280b24&lang=css"

import exportComponent from "/home/vsts/work/1/s/SeismicApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__